import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Title = styled.h1`
  font-family: 'Poppins Bold';
`;

export const SubTitle = styled.p`
  width: 520px;
  font-size: 16px;
  color: #0000008c;
`;
